// @flow
import * as Color from '../lib/Color';
import React, { Component } from 'react';
import {
  Button,
  Close,
  Input,
  Overlay,
  Panel,
  PanelFooter,
  PanelHeader,
  Pre,
  Space,
} from 'rebass';
import { spoonerizePhrase } from '../lib/Spoonerism';

const whitespace = /\s+/g;

const DEFAULT_SPOONERISM = 'spoonerism dot org';

const ESC = 27;

function normalize(str) {
  if (!str) {
    return '';
  }
  return str.trim().replace(whitespace, ' ');
}

export default class CreateSpoonerismOverlay extends Component {
  props: {
    defaultPhrase: ?string,
    onCancel: () => void;
    onCreate: (phrase: string) => void;
  };

  state = {
    phrase: '',
  };

  getSpoonerism() {
    const phrase = this.state.phrase || this.props.defaultPhrase || DEFAULT_SPOONERISM;
    return spoonerizePhrase(normalize(phrase));
  }

  handleKeyUp(evt: {keyCode: number}) {
    if (evt.keyCode === ESC) {
      this.props.onCancel();
    }
  }

  handleSubmit(evt: Event) {
    evt.preventDefault();
    this.props.onCreate(normalize(this.state.phrase));
    this.setState({phrase: ''});
  }

  render() {
    const { phrase } = this.state;
    const spoonerism = this.getSpoonerism();
    const background = Color.forString(spoonerism);
    const foreground = Color.complement(background);
    const { defaultPhrase, onCancel } = this.props;
    return (
      <Overlay
        open={true}
        onDismiss={onCancel}>
        <Panel style={{borderColor: background}}>
          <PanelHeader style={{backgroundColor: background}}>
            Create a spoonerism
            <Space auto={true} />
            <Close onClick={onCancel} />
          </PanelHeader>
          <form
            onKeyUp={this.handleKeyUp.bind(this)}
            onSubmit={this.handleSubmit.bind(this)}>
            <Input
              autoFocus={true}
              label="Enter a phrase to spoonerize"
              name="phrase"
              onChange={({target: {value}}) => this.setState({phrase: value})}
              placeholder={`e.g. ${defaultPhrase || DEFAULT_SPOONERISM}`}
              rounded={true}
              type="text"
              value={phrase}
            />
            <Pre>
              {spoonerism}
            </Pre>
            <PanelFooter style={{borderColor: background}}>
              <Space auto />
              <Button
                backgroundColor={phrase ? foreground : 'gray'}
                disabled={!phrase}
                type="submit">
                Create
              </Button>
            </PanelFooter>
          </form>
        </Panel>
      </Overlay>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CreateSpoonerismOverlay.js
 **/